import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Drawer, Space, Pagination, Switch, Tooltip } from 'antd';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import { useTheme } from "./theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import formatNumber from '../common_component/formatNumber.js';
import { ReportWidgetWrapper, ReportWidgetItem } from '../common_component/ReportWidgets.js';


function PaymentsMade() {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();

    const [paymentReceivedList, setPaymentReceivedList] = useState([])
    const [expenseList, setExpenseList] = useState([]);
    const [paymentReceivedType, setPaymentReceivedType] = useState(true);
    const [paymentReportApiState, setPaymentReportApiState] = useState(false)

    const daterange_picker_ref = useRef()
    const apiController = useRef(new AbortController())

    const [navtype, setnavtype] = useState("Overview");
    const [expenseUserName, setExpenseUserName] = useState("");
    const [expenseNumber, setExpenseNumber] = useState("");
    const [expenseFlag, setExpenseFlag] = useState(false);
    const [Expense_details, setExpense_details] = useState(null);
    const [Expense_history_details, setExpense_history_details] = useState([]);
    const [Expense_document_details, setExpense_document_details] = useState([]);
    const [Expense_recurrence_details, setExpense_recurrence_details] = useState(null);
    const [open, setOpen] = useState(false);
    const [Childopen, setChildopen] = useState(false);

    const [reportType, setReportType] = useState("All");
    const reportTypeArray = ["Vendor", "Manufacturer"];

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(30, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const [ImageModalShow, setImageModalShow] = useState(false);
    const [Image_src, setImage_src] = useState(false);
    const [baseCurrency, setBaseCurrency] = useState(null)

    const [flowModalShow, setFlowModalShow] = useState(false)

    var page_name = "payments-made";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function getExpenseReport(cp, rpp, search_v, sd, ed, report_type, report_for) {
        try {
            if (paymentReportApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setPaymentReportApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-payable-report`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, report_for: report_for, report_type: report_type, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation !== "success") throw "get Payable Report api error"

            setPaymentReceivedList(body.data.list)
            setListCount(body.data.count)
            setPaymentReportApiState(false)
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getExpenseDetails(id) {

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/expense-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setExpense_details(body.data[0]);
            setExpenseNumber(body.data[0].expense_number)
        }
        else {
            throw "expense details api error"
        }
    }

    async function getExpenseAdditionalDetails(id, flag) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/expense-additional-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "flag": flag, "document_flag": true, "history_flag": true, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setExpense_history_details(body.data.expense_history_details);
            setExpense_document_details(body.data.expense_document_details);
            setExpense_recurrence_details(body.data.recurrence_details[0]);
        }
        else {
            throw "expense additional details api error"
        }
    }

    async function getBaseCurrency() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        // console.log(body)
        if (body.length > 0) {
            setBaseCurrency(body[0])
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getExpenseReport(currentPage, rowsPerPage, searchValue, startDate, endDate, paymentReceivedType, reportType)
            let p2 = getBaseCurrency()

            Promise.all([p1, p2])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getExpenseReport(currentPage, rowsPerPage, searchValue, startDate, endDate, paymentReceivedType, reportType)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate, reportType])


    const setUpChildDrawer = (expense_id) => {
        setChildopen(true);
        setnavtype("Overview");
        setExpenseFlag(true);
        let p1 = getExpenseDetails(expense_id);
        let p2 = getExpenseAdditionalDetails(expense_id);
        Promise.all([p1, p2])
            .then(() => {
                setExpenseFlag(false);
            })
    }

    const onClose = () => {
        setOpen(false);
        setExpenseList([]);
    };

    const onChildClose = () => {
        setChildopen(false);
        setExpense_details(null);
        setExpense_history_details([]);
        setExpense_document_details([]);
    }

    const showImage = (src) => {
        setImage_src(src);
        setImageModalShow(true);
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Payments Made</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/reports/payables/payments_made`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...reportTypeArray.map(x => { return { label: x, value: x } })]}
                                            onChange={(event) => { setReportType(event.value); }}
                                            value={reportType !== "All" ? reportTypeArray.find(elem => elem.value == reportType) : { label: "All", value: "All" }}
                                            placeholder="Select..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                    {paymentReceivedType &&
                                        <div className='col-md-1'>
                                            <Switch checked={paymentReceivedType} onClick={(checked) => { setPaymentReceivedType(checked) }} style={{
                                                backgroundColor: 'blue',
                                                '&::checked': { backgroundColor: 'pink' },
                                            }} />
                                        </div>}
                                    {!paymentReceivedType &&
                                        <div className='col-md-3'>
                                            <DateRangePickerComponent
                                                ref={daterange_picker_ref}
                                                allowEdit={false}
                                                showClearButton={false}
                                                focus={() => { daterange_picker_ref.current.show() }}
                                                delayUpdate={true}
                                                presets={[
                                                    { label: 'Today', start: new Date(), end: new Date() },
                                                    { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                                    { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                                    { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                                                ]}
                                                change={(e) => {
                                                    setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                    setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                }}
                                                startDate={new Date(startDate)}
                                                endDate={new Date(endDate)}
                                                max={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                    }
                                </div>

                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-header border-0 pt-5">
                                        <ReportWidgetWrapper>
                                            <ReportWidgetItem
                                                icon={<i className="bi bi-clipboard-data-fill display-6 me-2" style={{ color: "#2d6a4f" }}></i>}
                                                label={"Total No. Of Transaction"}
                                                value={formatNumber(paymentReceivedList.reduce((p, o) => p + o.payable_count, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                            />
                                            <ReportWidgetItem
                                                icon={<i className="bi bi-cash-stack display-6 me-2" style={{ color: "#2d6a4f" }}></i>}
                                                label={"Total Transaction Amount"}
                                                value={baseCurrency.currency_symbol + formatNumber(paymentReceivedList.reduce((p, o) => p + o.total_payment_amount, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place, shorten: true, shortenFormat: '1K, 1L, 1Cr' })}
                                                hoverValue={baseCurrency.currency_symbol + formatNumber(paymentReceivedList.reduce((p, o) => p + o.total_payment_amount, 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                            />
                                        </ReportWidgetWrapper>
                                    </div>

                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                paymentReportApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    paymentReceivedList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3" style={{ minWidth: "1000px" }}>
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-120px">User Name</th>
                                                                            <th className="min-w-120px">Payment Count</th>
                                                                            <th className="min-w-120px">Payment Amount</th>
                                                                            {/* <th className="min-w-50px text-end">Actions</th> */}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            paymentReceivedList.map((obj, indx3) => {
                                                                                return (
                                                                                    <tr key={obj._id}>
                                                                                        <td><a className="cursor-pointer" onClick={(e) => { setExpenseUserName(""); setExpenseList([]); }}><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.payment_user_name}</span></a></td>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.payable_count}</span></td>
                                                                                        <td><span className="text-dark fw-bold d-block mb-1 fs-6">{baseCurrency.currency_symbol + formatNumber(obj.total_payment_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span></td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={ImageModalShow} onHide={() => { setImageModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setImageModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <img src={Image_src} style={{ height: "300px", padding: '25px', marginTop: '0' }} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setImageModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-80">
                <Modal.Header>
                    <Modal.Title>
                        <span className='text-gray-500'>Order Flow Cycle</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <img src={'./images/flow_images/customer-order.png'} className='w-100' alt="Not yet provided" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setFlowModalShow(false) }}>Cancel</button>
                </Modal.Footer>
            </Modal>

            <Drawer title={expenseUserName} width={window.innerWidth > 1200 ? 600 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>
                    </Space>
                }

            >
                <div className="card">
                    <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                        <div className="card-body p-9">
                            {expenseList.length > 0 && expenseList.map((obj3, indx3) => {
                                return (
                                    <>
                                        <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Expense Number</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        <span className="me-2" >{obj3.expense_number}</span>
                                                        <a onClick={(e) => { setUpChildDrawer(obj3.expense_id) }} className="text-primary opacity-75-hover fw-semibold">View Expense</a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Expense Date</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {moment(obj3.expense_date).format("ll")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {obj3.expense_amount}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Timestamp</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {moment(obj3.timestamp).format("lll")}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label className="col-lg-4 fw-semibold text-muted">Expense Status</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">
                                                        {obj3.expense_status === "EXPENSE_APPROVED" ?
                                                            <span className="badge badge-primary">Approved</span>
                                                            :
                                                            obj3.expense_status === "EXPENSE_PAID" &&
                                                            <span className="badge badge-success">Paid</span>
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                            }
                        </div>
                    </div>
                </div>
                <Drawer
                    title={expenseNumber}
                    width={window.innerWidth > 1200 ? 800 : 'auto'}
                    onClose={onChildClose}
                    open={Childopen}
                    closeIcon={<a onClick={onChildClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
                    </a>}
                >
                    <div className="card">
                        <div className="d-flex w-100 overflow-auto">
                            <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                <li className="nav-item mx-lg-1">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Transaction</a>
                                </li>
                                {Expense_details != null && Expense_details.recurrence_expense_flag == true &&
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Recurrence" && "active"}`} onClick={(e) => { setnavtype("Recurrence"); }}>Recurrence details</a>
                                    </li>}
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Attachments" && "active"}`} onClick={(e) => { setnavtype("Attachments"); }}>Attachments</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="card">
                        {(navtype === "Overview") ?
                            <>
                                <div
                                    className="card border-primary mb-3 mt-2"
                                    style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                                >
                                    {(expenseFlag !== true && Expense_details !== null) ?
                                        <div className="card-body p-3">
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Expense Date</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{moment(Expense_details.expense_date).format("ll")}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{Expense_details.branch_name}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Status
                                                    </label>
                                                    <div className="col-lg-8 d-flex align-items-center">
                                                        {Expense_details.add_status === "EXPENSE_APPROVED" ?
                                                            <span className="badge badge-primary">Approved</span>
                                                            :
                                                            Expense_details.add_status === "EXPENSE_PAID" &&
                                                            <span className="badge badge-success">Paid</span>
                                                        }
                                                    </div>
                                                </div>
                                                {Expense_details.add_status === "PAID" &&
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Paid Through Account</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.account_head_name}`}</span>
                                                        </div>
                                                    </div>}
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.currency.currency_code}`}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Source Of Supply</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.source_of_supply}`}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Destination Of Supply</label>
                                                    <div className="col-lg-8 fv-row">
                                                        <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.destination_of_supply}`}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Tax Detils</label>
                                                    <div className="col-lg-8 fv-row">
                                                        {Expense_details.gstin_details != null && <span className="fw-semibold text-gray-800 fs-6">{`${Expense_details.gstin_details.GstIn},${Expense_details.gstin_details.gst_treatment}`}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Invoice</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-semibold fs-6 text-gray-800">{Expense_details.remarks}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            </>
                            :
                            navtype === "Transactions" ?
                                <>
                                    <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                        <div className="card-body p-9">
                                            {expenseFlag !== true ?
                                                <div>
                                                    {Expense_details !== null && Expense_details.account_details.map((obj3, indx3) => {
                                                        return (
                                                            <>
                                                                <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Account Name</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.account_name}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Calculation Method</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.calculation_mode == "Tax_Exclusive" ? <>Tax Exclusive</> : <>Tax Inclusive</>}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.original_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    {obj3.tax !== null &&
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">Tax</label>
                                                                            <div className="col-lg-8">
                                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                                    {obj3.tax_amount}
                                                                                </span>
                                                                            </div>
                                                                        </div>}
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Total amount</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {obj3.total_amount}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                    }
                                                </div>
                                                :
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            }
                                        </div>
                                    </div>
                                </>
                                :
                                navtype === "Recurrence" ?
                                    <>
                                        {Expense_details != null &&
                                            <div className="card-body p-9">
                                                {expenseFlag !== true ?
                                                    <>
                                                        <div
                                                            className="card border-primary mb-3 mt-2"
                                                            style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                                                        >
                                                            <div className="card-body p-3">
                                                                <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Profile Name</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {Expense_recurrence_details.profileName}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Start Date</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {moment(Expense_recurrence_details.start_date).format("ll")}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">End Date</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {moment(Expense_recurrence_details.end_date).format("ll")}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Any time check</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {Expense_recurrence_details.any_time_check ? <>True</> : <>False</>}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Frequency</label>
                                                                        <div className="col-lg-8">
                                                                            <span className="fw-bold fs-6 text-gray-800">
                                                                                {Expense_recurrence_details.frequency_details.frequency + " " + Expense_recurrence_details.frequency_details.time_period}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mb-2">
                                                                        <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                                        <div className="col-lg-8">
                                                                            {Expense_recurrence_details.add_status === "cancelled" ?
                                                                                <span className="badge badge-danger">Cancelled</span>
                                                                                :
                                                                                Expense_recurrence_details.add_status === "expired" ?
                                                                                    <span className="badge badge-danger">Expired</span>
                                                                                    :
                                                                                    Expense_recurrence_details.add_status === "Active" &&
                                                                                    <span className="badge badge-success">Active</span>

                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                }
                                            </div>
                                        }
                                    </>
                                    :
                                    navtype === "Attachments" ?
                                        <>
                                            {Expense_details != null &&
                                                <div className="card-body p-9">
                                                    {expenseFlag !== true ?
                                                        <>
                                                            {Expense_document_details.length > 0 &&
                                                                <div className="overflow-auto pb-5">
                                                                    <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7">
                                                                        {Expense_document_details.map((obj, index) => {
                                                                            return (
                                                                                <>
                                                                                    <div key={index} className="overlay me-10">
                                                                                        <div className="overlay-wrapper">
                                                                                            <img alt="img" className="rounded w-150px" src={(`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/expense_documents/${organization_id}/`, (obj.file_name))} />
                                                                                        </div>
                                                                                        <div className="overlay-layer bg-dark bg-opacity-10 rounded">
                                                                                            <a onClick={() => showImage((`${process.env.REACT_APP_GENERAL_IMAGE_BUCKET}`).concat(`/expense_documents/${organization_id}/`, (obj.file_name)))} className="btn btn-sm btn-primary btn-shadow me-1">View</a>
                                                                                            {/* <a onClick={() => { setRemoveAttachmentDetails(obj); setRemoveAttachmentModalShow(true) }} className="btn btn-sm btn-danger btn-shadow">Delete</a> */}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                    }
                                                </div>
                                            }
                                        </>
                                        :
                                        navtype === "History" &&
                                        <>
                                            {Expense_details != null &&
                                                <div className="card-body p-9">
                                                    {expenseFlag !== true ?
                                                        <>
                                                            {Expense_history_details.length > 0 && Expense_history_details.map((obj, index) => {
                                                                return (
                                                                    <>
                                                                        <div key={index} className="m-0">
                                                                            <div className="d-flex align-items-sm-center mb-5">
                                                                                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                                    <div className="flex-grow-1 me-2">
                                                                                        <span className={obj.expense_status === "EXPENSE_PENDING_APPROVAL" ? "badge badge-light-warning me-2" : obj.expense_status === "EXPENSE_DRAFT" ? "badge badge-secondary me-2" : obj.expense_status === "EXPENSE_APPROVED" ? "badge badge-primary" : obj.expense_status === "EXPENSE_PAID" ? "badge badge-success" : (obj.expense_status === "EXPENSE_CANCELLED" || obj.expense_status === "EXPENSE_REJECTED") && "badge badge-danger"}>{obj.expense_status}</span>
                                                                                        {(obj.expense_status === "EXPENSE_PENDING_APPROVAL" || obj.expense_status === "EXPENSE_DRAFT") && <span className="badge badge-light-primary">{obj.operation == "create" ? <>Create</> : <>Update</>}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="timeline">
                                                                                <div className="timeline-item align-items-center mb-7">
                                                                                    <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                        <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                        <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                                    </svg>
                                                                                    </span>
                                                                                    <div className="timeline-content m-0">
                                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                        <span className="fs-6 fw-bold text-gray-800">{moment(obj.timestamp).format("lll")} </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="timeline-item align-items-center">
                                                                                    <div className="timeline-line w-40px"></div>
                                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                        <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                        <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                                    </svg>
                                                                                    </span>
                                                                                    <div className="timeline-content m-0">
                                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                        <span className="fs-6 fw-bold text-gray-800">{obj.user}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {Expense_history_details.length > 1 &&
                                                                            <div className="separator separator-dashed my-6"></div>
                                                                        }
                                                                    </>
                                                                )
                                                            })}
                                                        </>
                                                        :
                                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                    }
                                                </div>
                                            }
                                        </>
                        }
                    </div>
                </Drawer>
            </Drawer>
        </>
    );
}

export default PaymentsMade;